var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgValidationCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 6
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "m1.527 2.538 1.425 1.408 3.52-3.48a.75.75 0 1 1 1.055 1.067l-4.048 4a.75.75 0 0 1-1.054 0L.473 3.605a.75.75 0 0 1 1.054-1.067"
})));
export { SvgValidationCheck as ReactComponent };
export default __webpack_public_path__ + "static/media/validation-check.747fec91.svg";